import CustomVariantPicker from '@theme/custom-variant-picker';
import { Component } from '@theme/component';
import { VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays a variant picker with swatches (custom version).
 *
 * @typedef {object} CustomSwatchesRefs
 * @property {HTMLElement} overflowList
 *
 * @extends {CustomVariantPicker<CustomSwatchesRefs>}
 */
class CustomSwatchesVariantPickerComponent extends CustomVariantPicker {
  constructor() {
    super();
  }
  /**
   * Shows all swatches.
   * @param {Event} [event] - The event that triggered the show all swatches.
   */
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();
    this.addEventListener('change', this.variantChanged?.bind(this));
  }

  showAllSwatches(event) {
    event?.preventDefault();
    const { overflowList } = this.refs;
    if (overflowList && typeof overflowList.showAll === 'function') {
      // @ts-ignore
      overflowList.showAll();
    }
  }

  /**
   * Hide the variant images that are not for the selected variant.
   */
  #updateVariantImages() {
    // Asume que refs.slideshow existe y que los slides tienen slide-id y variant-image
    const { slideshow } = this.refs || {};
    if (!this.variantPicker?.selectedOption) {
      console.warn('[CustomSwatchesVariantPickerComponent][DEBUG] No selectedOption');
      return;
    }
    const selectedImageId = this.variantPicker?.selectedOption.dataset.optionMediaId;
    if (slideshow && selectedImageId) {
      const { slides = [] } = slideshow.refs || {};
      for (const slide of slides) {
        if (slide.getAttribute('variant-image') == null) continue;
        const isVisible = slide.getAttribute('slide-id') === selectedImageId;
        slide.hidden = !isVisible;
      }
    } else {
      console.warn('[CustomSwatchesVariantPickerComponent][DEBUG] slideshow or selectedImageId missing', {slideshow, selectedImageId});
    }
  }

}

if (!customElements.get('custom-swatches-variant-picker-component')) {
  customElements.define('custom-swatches-variant-picker-component', CustomSwatchesVariantPickerComponent);
}

/**
 * Custom Product Card: escucha eventos VariantUpdateEvent y actualiza galería/picker + imágenes.
 */
class CustomProductCard extends Component {
  connectedCallback() {
    super.connectedCallback?.();
  }

  /**
   * Devuelve el picker custom hijo.
   */
  get variantPicker() {
    return this.querySelector('custom-swatches-variant-picker-component');
  }

}

if (!customElements.get('custom-product-card')) {
  customElements.define('custom-product-card', CustomProductCard);
}
